import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Card, Box, Typography, Button, CircularProgress } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { API_ENDPOINTS } from "../../../config/api";

const API_URL = API_ENDPOINTS.REGIONS.BASE;

const ProductDetailsContent = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProduct();
  }, []);

  const fetchProduct = async () => {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      setProduct(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching product details:", error);
      setLoading(false);
    }
  };

  if (loading) {
    return <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />;
  }

  if (!product) {
    return <Typography variant="h6" sx={{ textAlign: "center", mt: 5 }}>Product not found</Typography>;
  }

  return (
    <Box component="section">
    <Card sx={{ boxShadow: "none", borderRadius: "7px", padding: "25px", maxWidth: 600, margin: "auto", mt: 5 }}>
      <Link to="/ecommerce/products-list">
        <Button variant="outlined" startIcon={<ArrowBackIcon />}>Back to Products</Button>
      </Link>
      <Box sx={{ mt: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>{product.product_name}</Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>Brand: {product.brand || "N/A"}</Typography>
        <Typography variant="body1" sx={{ mt: 1 }}>Description: {product.description || "No description available."}</Typography>
        <Typography variant="body1" sx={{ mt: 1 }}>Price: ${product.price || "N/A"}</Typography>
      </Box>
    </Card>
    </Box>
  );
};

export default ProductDetailsContent;
